import { MockBridge } from './MockBridge.ts';
import { MaxBridge } from './MaxBridge.ts';
import { TelegramBridge } from './TelegramBridge.ts';
import type { PlatformBridge } from './types.ts';

export type { PlatformBridge, PlatformType, PlatformUser, ThemeColors } from './types.ts';
export { MockBridge } from './MockBridge.ts';
export { MaxBridge } from './MaxBridge.ts';
export { TelegramBridge } from './TelegramBridge.ts';

/**
 * Определяет платформу и возвращает соответствующий bridge.
 * Порядок определения: MAX → Telegram → Mock (dev/fallback)
 */
export function createPlatformBridge(): PlatformBridge {
  // Проверяем наличие непустого initData: SDK может быть загружен в браузере
  // и выставлять window.WebApp с initData = "" — это не MAX-среда
  if (typeof window !== 'undefined' && window.WebApp?.initData) {
    return new MaxBridge();
  }
  if (typeof window !== 'undefined' && window.Telegram?.WebApp) {
    return new TelegramBridge();
  }
  return new MockBridge();
}
